import {
  areLockedFixedRouteDropPassengersCompatible,
  createErrorResult,
  createSuccessResult,
  errors,
  getDraggedPassengersInfo,
  isLockedFixedRouteDropTargetDto,
  Log,
  passengersStationsContain,
  type IRideDto,
  type SimpleResult,
} from "@ryde/shared";

import type { IRideDragData } from "../drag-handlers";

export const useFixedRidesUtils = () => {
  const getCheckingStationsIds = (fixedRide: Partial<IRideDto>): number[] => {
    return fixedRide.metadata?.stationIds || [];
  };

  const isFixedRideMergeAble = ({
    dragSource,
    dropTarget,
  }: IRideDragData): SimpleResult<void> => {
    const dragRideDto = dragSource.payload.rideDto;
    const dropRideDto = dropTarget.rideDrop;

    if (!dragRideDto || !dropRideDto) {
      return createErrorResult(errors.ride.invalidRideId, "Invalid ride ID");
    }

    const passengersDragCombined = getDraggedPassengersInfo(dragSource);
    const isDropLockedFixedRoute = isLockedFixedRouteDropTargetDto(dropRideDto);

    // Allow-merge stays droppable here; station/order convert is confirmed when the drop is committed.
    if (!isDropLockedFixedRoute) {
      return createSuccessResult();
    }

    if (dropRideDto.courseId) {
      Log.debug(
        "isFixedRideMergeAble: drop ride is locked fixed ride, passengers",
        passengersDragCombined,
      );

      if (
        !areLockedFixedRouteDropPassengersCompatible({
          dropRideDto,
          sourceRideDto: dragRideDto,
          passengers: passengersDragCombined ?? [],
        })
      ) {
        return createErrorResult(
          errors.ride.shuttlePassengerMoveNotCompatible,
          "Checking: drop locked fixed ride, stations or route order incompatible",
        );
      }

      return createSuccessResult();
    } else if (dragRideDto.courseId) {
      const stationsIds = getCheckingStationsIds(dragRideDto);
      Log.debug(
        "Checking isFixedRideMergeAble: drag ride is fixed ride, passengers",
        passengersDragCombined,
        "Stations ids:",
        stationsIds,
      );

      if (!passengersStationsContain(stationsIds, passengersDragCombined)) {
        return createErrorResult(
          errors.ride.rideDropStationsMismatch,
          "Checking: drag ride is fixed ride, isFixedRideMergeAble: false",
        );
      }
    }

    Log.debug(
      "Checking Fix ride is droppable for passengers:",
      passengersDragCombined,
    );
    return createSuccessResult();
  };

  return { isFixedRideMergeAble };
};
